import * as types from '../types/campaign_code';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestCheckCampaignCode = actionCreator(types.REQUEST_CHECK_CAMPAIGN_CODE);
export var successCheckCampaignCode = actionCreator(types.SUCCESS_CHECK_CAMPAIGN_CODE);
export var failureCheckCampaignCode = actionCreator(types.FAILURE_CHECK_CAMPAIGN_CODE);
export var clearCheckCampaignCode = actionCreator(types.CLEAR_CHECK_CAMPAIGN_CODE);